const chartWindowIdPattern = /^chart-window-([1-9]\d*)$/;

export function restorableChartWindows(savedWindows, maximumChartWindows) {
  if (maximumChartWindows === 0) return [];
  return Array.isArray(savedWindows) ? savedWindows.slice(0, 24) : [];
}

/**
 * Reserves either a persisted chart-window identity or the next generated one.
 * Persisted identities remain stable so server-side grandfathering can compare
 * the same window across reloads.
 */
export function reserveChartWindowId({
  requestedId = null,
  existingIds = [],
  sequence = 0
} = {}) {
  const usedIds = new Set(existingIds);
  const currentSequence = Number.isSafeInteger(sequence) && sequence >= 0
    ? sequence
    : 0;

  if (requestedId !== null && requestedId !== undefined) {
    const match = typeof requestedId === "string"
      ? chartWindowIdPattern.exec(requestedId)
      : null;
    const requestedSequence = match ? Number(match[1]) : Number.NaN;
    if (!Number.isSafeInteger(requestedSequence)) {
      throw new TypeError("The saved chart window ID is invalid.");
    }
    if (usedIds.has(requestedId)) {
      throw new TypeError("The saved chart workspace contains duplicate window IDs.");
    }
    return {
      id: requestedId,
      sequence: Math.max(currentSequence, requestedSequence)
    };
  }

  let nextSequence = currentSequence;
  let id;
  do {
    if (nextSequence >= Number.MAX_SAFE_INTEGER) {
      throw new RangeError("A unique chart window ID could not be allocated.");
    }
    nextSequence += 1;
    id = `chart-window-${nextSequence}`;
  } while (usedIds.has(id));

  return { id, sequence: nextSequence };
}
